import css from "./Header.module.scss";
import Breadcrumbs from "../atoms/Breadcrumbs";
import Dropdown from "../molecules/Dropdown";
import Notification from "../molecules/Notification";
import DropdownLink from "../atoms/DropdownLink";
import { Link, useNavigate } from "react-router-dom";
import { useSidebar } from "src/utils/SidebarProvider";

import { logout } from "src/slices/auth";
import { useDispatch, useSelector } from "react-redux";
import Pill from "../atoms/Pill";
import { useState } from "react";

export default function Header({ path, user, toggleOpen }) {
    const dispatch = useDispatch();
    const { type } = useSelector((state) => state.auth);

    const navigate = useNavigate();
    const handleLogout = () => {
        dispatch(logout());
        navigate("/login");
    };

    const { toggleSidebar } = useSidebar();

    return (
        <div className={css["header"]}>
            <i
                className={`fad fa-bars ${css.icon} ${css["icon--sidebar"]}`}
                onClick={toggleSidebar}
            />
            <Breadcrumbs path={path} />
            {/* <Dropdown iconName="bell">
                
                <Notification
                    date="12 Nov, 15:30"
                    title="New Order"
                    text="A new order has been placed blah blah sdjfh. Lorem ipsum dolor sit amet $100 sdfhj owe. oieutwpo apsiowrq ljd."
                />
                <Notification
                    date="12 Nov, 18:41"
                    title="New Order"
                    text="A new order has been placed blah blah sdjfh. Lorem ipsum dolor sit amet $100 sdfhj owe. oieutwpo apsiowrq ljd."
                />
                <Notification
                    date="12 Nov, 17:30"
                    title="New Order"
                    text="A new order has been placed blah blah sdjfh. Lorem ipsum dolor sit amet $100 sdfhj owe. oieutwpo apsiowrq ljd."
                />
            </Dropdown> */}
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                }}
            >
                <Pill
                    label={
                        ["merchant", "employee"].includes(type)
                            ? type == "merchant"
                                ? "Admin"
                                : "Employee"
                            : "Not Logged In"
                    }
                    color={
                        ["merchant", "employee"].includes(type)
                            ? type == "merchant"
                                ? "orange"
                                : "blue"
                            : "red"
                    }
                    variant="secondary"
                />
                <Link to="/home" style={{ marginLeft: "8px" }}>
                    <i className={`fad fa-home ${css.icon}`} />
                </Link>
                <Dropdown
                    iconName="user"
                    gap="2px"
                    items={[
                        { label: "Profile", link: "/profile" },
                        {
                            label: "Support",
                            link: "/support",
                            icon: "life-ring",
                        },
                        // { label: "Lock",
                        // icon:"lock-alt"}
                        {
                            label: "Log out",
                            action: handleLogout,
                            icon: "sign-out",
                            color: "red",
                        },
                    ]}
                />
            </div>
        </div>
    );
}
